{
  "meta": {
    "title": "Ande Line Request",
    "description": "{{date}} at {{time}} for {{partySize}}",
    "descriptionFlexible": "{{date}} between {{start}} and {{end}} for {{partySize}}",
    "descriptionFlexibleDates": "Flexible on dates (“{{dates}}”) for {{partySize}}"
  },
  "header": {
    "label": "Ande Line Request"
  },
  "details": {
    "partySize": "Party size",
    "date": "Date",
    "flexibleDates": "Dates (flexible)",
    "time": "Time",
    "flexibleTime": "Time (flexible)",
    "timeWindow": "{{start}} – {{end}}",
    "attribution": "Requested on behalf of a client via Ande."
  },
  "form": {
    "decision": {
      "legend": "Can you accommodate this request?",
      "accept": "Yes, we can accommodate",
      "decline": "No, we can't accommodate"
    },
    "minimumSpend": {
      "label": "Minimum spend",
      "hint": "Optional — leave blank if none applies",
      "placeholder": "e.g., $100",
      "basis": {
        "legend": "Is that per person or for the whole table?",
        "perPerson": "Per person",
        "table": "For the whole table"
      }
    },
    "night": {
      "label": "Night",
      "hint": "Required to accept — the guest is flexible on dates: “{{dates}}”"
    },
    "alternateTime": {
      "label": "Alternate time",
      "hint": "Optional — only if {{time}} doesn't work",
      "placeholder": "e.g., 8:30 PM instead"
    },
    "seatingTime": {
      "label": "Seating time",
      "hint": "Required to accept — the guest is flexible between {{start}} and {{end}}",
      "placeholder": "e.g., 7:30 PM"
    },
    "alternatePartySize": {
      "label": "Party size you can seat",
      "hint": "Optional — only if you can't seat all {{partySize}}",
      "placeholder": "e.g., 4"
    },
    "notes": {
      "label": "Notes",
      "placeholder": "Notes for Ande (optional)"
    },
    "submit": "Send response to Ande",
    "submitting": "Sending...",
    "error": "We couldn't send your response. Please try again.",
    "missingSeatingTime": "Add the time you can seat them to accept this request.",
    "missingNight": "Add the night you can seat them to accept this request.",
    "missingMinimumSpendBasis": "Say whether the minimum spend is per person or for the whole table."
  },
  "confirmed": {
    "heading": {
      "accepted": "Response sent — accepted",
      "declined": "Response sent — declined"
    },
    "minimumSpend": "Minimum spend of {{minimumSpend}} noted",
    "minimumSpendPerPerson": "Minimum spend of {{minimumSpend}} per person noted",
    "minimumSpendTable": "Minimum spend of {{minimumSpend}} for the whole table noted",
    "alternateTime": "Alternate time of {{alternateTime}} noted",
    "seatingTime": "Seating time of {{alternateTime}} noted",
    "night": "Night of {{night}} noted",
    "alternatePartySize": "Party of {{partySize}} noted",
    "requested": "The guest asked for {{partySize}} at {{time}}",
    "notes": "Notes: {{notes}}"
  },
  "expired": {
    "heading": "This link has expired",
    "body": "A response has already been submitted for this request.",
    "back": "Back to Messages"
  }
}
